import { Navigate, Route, Routes } from "react-router-dom";
import { AppLayout } from "../AppLayout";
import StandaloneHomePage from "./home/StandaloneHomePage";
import StandaloneLegalDocPage from "./legal/StandaloneLegalDocPage";
import { TactikAppShell } from "./app/TactikAppShell";
import TactikProductPage from "./app/TactikProductPage";
import StandaloneCheckoutPage from "./order/CheckoutPage";
import StandaloneOrdersPage from "./order/StandaloneOrdersPage";
import MyNotesPage from "../products/my_notes/MyNotesPage";
import { getStandaloneSpaceId } from "./config";

/** Tactik 独立站路由 */
function StandaloneApp() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path="/" element={<StandaloneHomePage />} />
        <Route path="/follows" element={<Navigate to="/" replace />} />
        <Route path="/subscriptions" element={<Navigate to="/" replace />} />
        <Route path="/orders" element={<Navigate to="/tactik/orders" replace />} />
        <Route path="/legal/:slug" element={<StandaloneLegalDocPage />} />
        <Route path="/tactik" element={<TactikAppShell />}>
          <Route index element={<Navigate to="intel" replace />} />
          <Route path="orders" element={<StandaloneOrdersPage />} />
          <Route
            path="my-notes"
            element={<MyNotesPage spaceId={getStandaloneSpaceId()} />}
          />
          <Route path=":segment" element={<TactikProductPage />} />
        </Route>
        <Route path="/tactik/checkout/:orderId" element={<StandaloneCheckoutPage />} />
        <Route path="/space/*" element={<Navigate to="/tactik/intel" replace />} />
        <Route path="/checkout/*" element={<Navigate to="/tactik/orders" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default StandaloneApp;
